import {
  SmartInterviewsBuilder,
  UpdateVisibilitySmartInterviewInput,
} from '../smart-interviews.types';

export const updateVisibilitySmartInterview = (
  builder: SmartInterviewsBuilder
) =>
  builder.mutation<void, UpdateVisibilitySmartInterviewInput>({
    query: (payload) => ({
      url: `/candidates/smart-interviews/visibility`,
      method: 'PATCH',
      body: payload,
    }),
    invalidatesTags: () => [{ type: 'SmartInterviewsVideos' }],
  });
